import { render, staticRenderFns } from "./form-login.vue?vue&type=template&id=647ed8c9"
import script from "./form-login.vue?vue&type=script&lang=js"
export * from "./form-login.vue?vue&type=script&lang=js"
import style0 from "./form-login.vue?vue&type=style&index=0&id=647ed8c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports